import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

function RegisterPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Helmet><title>Registrieren | 1688 Deutschland</title></Helmet>
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Registrieren</h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={(e) => e.preventDefault()}>
          <div className="space-y-4">
             <input type="text" required className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Name" />
            <input type="email" required className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="E-Mail Adresse" />
            <input type="password" required className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Passwort" />
          </div>
          <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">
            Registrieren
          </button>
        </form>
        <div className="text-center">
          <Link to="/login" className="text-blue-600 hover:text-blue-500">Bereits ein Konto? Anmelden</Link>
        </div>
      </div>
    </div>
  )
}

export default RegisterPage